import React from "react";
import Sparkline from "./Sparkline";

/**
 * SkuTimelineTrends – renders 4 sparklines (China Price, Shipping, Weight, Qty)
 * derived from a timeline's events array. Timeline events are LIFO (newest first),
 * so we reverse them for chronological display.
 */
export default function SkuTimelineTrends({ events = [] }) {
  const chrono = [...events].reverse();
  const price = chrono.map((e) => (e.china_price !== undefined && e.china_price !== null ? Number(e.china_price) : null)).filter((v) => v !== null);
  const shipping = chrono.map((e) => (e.china_shipping !== undefined && e.china_shipping !== null ? Number(e.china_shipping) : null)).filter((v) => v !== null);
  const weight = chrono.map((e) => (e.china_weight_gram !== undefined && e.china_weight_gram !== null ? Number(e.china_weight_gram) : null)).filter((v) => v !== null);
  const qty = chrono.map((e) => (e.china_qty_to_order !== undefined && e.china_qty_to_order !== null ? Number(e.china_qty_to_order) : null)).filter((v) => v !== null);
  const transit = chrono.map((e) => (e.transit_days !== undefined && e.transit_days !== null ? Number(e.transit_days) : null)).filter((v) => v !== null);

  if (!chrono.length) return null;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 p-4 border-b border-slate-200 bg-slate-50">
      <div className="bg-white border border-slate-200 rounded-sm p-2">
        <Sparkline label="Price ¥ trend" values={price} suffix="¥" color="#0284c7" fill="rgba(2,132,199,0.15)" deltaMode="lower" />
      </div>
      <div className="bg-white border border-slate-200 rounded-sm p-2">
        <Sparkline label="Shipping ¥ trend" values={shipping} suffix="¥" color="#7c3aed" fill="rgba(124,58,237,0.15)" deltaMode="lower" />
      </div>
      <div className="bg-white border border-slate-200 rounded-sm p-2">
        <Sparkline label="Weight (g) trend" values={weight} suffix="g" color="#059669" fill="rgba(5,150,105,0.15)" deltaMode="lower" />
      </div>
      <div className="bg-white border border-slate-200 rounded-sm p-2">
        <Sparkline label="Qty ordered" values={qty} suffix=" u" color="#d97706" fill="rgba(217,119,6,0.18)" deltaMode="higher" />
      </div>
      <div className="bg-white border border-slate-200 rounded-sm p-2">
        <Sparkline label="Transit (days)" values={transit} suffix="d" color="#dc2626" fill="rgba(220,38,38,0.15)" deltaMode="lower" />
      </div>
    </div>
  );
}
